import { AchievementUnlocked } from "../AchievementUnlocked";

export const Achievement1Content = ({ step, earnings }) => {
  switch (step) {
    case 0:
      return <AchievementUnlocked
        title={'Achievement Unlocked'}
        earnings={earnings}
        textBefore={'FOR COMPLETING YOUR 1ST BATTLE'}
        textAfter={'VIEW FOOD AND DRINK ITEMS HERE'}
        arrowSelector={`[data-tutorial-anchor="menu-button-3"]`}
      />
    case 1:
      return <AchievementUnlocked
        title={'EAT AND DRINK TO REGAIN STRENGTH AND LEVEL UP'}
        mediaItems={[{
          image_url: '/assets/icon_health_white.svg',
          className: 'media-item-large'
        }]}
        textLines={[
          'CONSUMING FOOD AND DRINK',
          '1. GETS YOU BACK TO MAX HEALTH',
          '2. INCREASES TOTAL HEALTH POINTS'
        ]}
        arrowSelector={`[data-tutorial-anchor="navbar-stat-1"]`}
      />
  }
};